import { render, staticRenderFns } from "./veStuCheckModifyAdmin.vue?vue&type=template&id=3b4327d5&scoped=true"
import script from "./veStuCheckModifyAdmin.vue?vue&type=script&lang=js"
export * from "./veStuCheckModifyAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4327d5",
  null
  
)

export default component.exports